<div class="sticky top-0 sidebar bg-gray-950 p-3 h-screen overflow-visible"
  [ngClass]="{ 'w-fit': collapsed, 'w-screen md:w-[300px]': !collapsed }">
  <div class="sidebar-header flex flex-row justify-between gap-5 items-center mb-3">
    <div *ngIf="!collapsed" class="">
      <img src="/assets/img/logo4.png" class="ml-12 h-[40px] object-contain" alt="" />
    </div>
    <a (click)="toggleSidebar()" class="hover:bg-gray-800 px-4 py-3 rounded-lg">
      <tui-svg [src]="
          collapsed ? 'tuiIconChevronsRightLarge' : 'tuiIconChevronsLeftLarge'
        " class="w-11 h-11 text-gray-500"></tui-svg>
    </a>
  </div>
  <div class="flex flex-col h-full justify-between">
    <ul class="sidevav-nav">
      <li class="nav-item relative z-[0]" *ngFor="let data of SidebarData">
        <a [ngClass]="{ active: isSubMenuExpanded(data) }"
          class="sidebar-nav-link bg-gray-800 px-4 py-3 flex flex-row gap-4 items-center rounded-lg mb-3 group"
          [routerLink]="data.routerLink ? [data.routerLink] : []" (click)="toggleSubMenu(data)"
          *ngIf="checkPermission(data.label)">
          <tui-svg class="text-gray-500 nav-icon group-hover:text-accent" [src]="data.icon"></tui-svg>
          <h3 class="sidebar-nav-text text-gray-400 text-[15px] font-bold group-hover:text-accent" *ngIf="!collapsed">
            {{ data.label }}
          </h3>
        </a>

        <ul *ngIf="isSubMenuExpanded(data) && !collapsed" class="mb-3" [@slideInOut]>
          <li class="sub-nav-item" *ngFor="let subItem of data.subMenu">
            <a [ngClass]="{ active: router.isActive(subItem.routerLink, true) }"
              class="group sidebar-nav-link flex flex-row items-center ml-5 gap-5" [routerLink]="[subItem.routerLink]"
              (click)="closeBarMobile()">
              <div class="">
                <div class="h-8 w-[3px] line bg-gray-900 group-hover:bg-accent"></div>
              </div>
              <h3 class="text-[15px] text-gray-300 font-semibold" *ngIf="!collapsed">
                {{ subItem.label }}
              </h3>
            </a>
          </li>
        </ul>
      </li>
    </ul>
    <a class="sidebar-nav-link bg-gray-800 px-4 py-3 flex flex-row gap-4 rounded-lg group mb-16" (click)="logout()">
      <tui-svg class="text-gray-500 nav-icon group-hover:text-red-500 rotate-180" src="tuiIconLogOut"></tui-svg>
      <h3 class="sidebar-nav-text text-gray-300 font-semibold text-[15px] group-hover:text-red-500" style="cursor: pointer"
        *ngIf="!collapsed">
        Logout
      </h3>
    </a>
  </div>
</div>